<template>
  <div class="myProfile">
    <van-nav-bar
      class="nav_bar"
      title="我的资料"
      left-arrow
      placeholder
      @click-left="onClickLeft"
    />
    <Personal></Personal>
  </div>
</template>

<script>
import Personal  from './editProfile'
export default {
  name: "myProfile",
  data() {
    return {

    }
  },
  components:{Personal},
  mounted(){

  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="stylus">
</style>